










































import { Component, Inject, Mixins } from "vue-property-decorator";
import Context from "@/mixins/context";
import {
  IInvoiceProvider,
  IInvoiceProviderMethods
} from "@/models/providers/invoice";

@Component({
  components: {
    "invoice-payment-item": () =>
      import("@/components/app/global/payments/invoicePaymentItem.vue")
  }
})
export default class InvoicePaymentsList extends Mixins(Context) {
  // Inject

  @Inject({ from: "invoiceProvider" })
  public readonly $invoiceProvider!: () => IInvoiceProvider;

  @Inject({ from: "invoiceProviderMethods" })
  public readonly $invoiceMethods!: IInvoiceProviderMethods;

  // Computed

  public get $invoiceData() {
    return this.$invoiceProvider();
  }

  public get payments() {
    return this.$_.orderBy(
      this.$invoiceData.invoice && this.$invoiceData.invoice?.payments,
      ["first_date_time_captured"],
      ["desc"]
    );
  }

  public get skeletonSize() {
    return this.payments.length || 3;
  }

  public get showEmptyState() {
    return !this.$invoiceData.isLoading && !this.payments.length;
  }
}
